import i18n from '@/plugins/i18n'

export default {
  methods: {
    getErrorMessage(error) {
      if (error.response.data && error.response.data.code) {
        return i18n.t(`errors.messages.${error.response.data.code}`, {message: error.response.data.message})
      } else if (error.response.data && error.response.data.message) {
        return i18n.t('errors.messages.DP-1', {message: error.response.data.message})
      } else {
        return i18n.t('errors.messages.DP-1', {message: error.response.data})
      }
    }
  }
}
